<app-social-shell [active]="isMe ? 'profile' : 'none'">
  @if (loading) {
    <div class="so-card so-hero">
      <div class="so-hero-cover"></div>
      <div class="so-hero-body">
        <span class="so-avatar so-avatar--xl so-skel"></span>
        <div class="so-hero-info"><span class="so-skel" style="height: 22px; width: 50%"></span></div>
      </div>
    </div>
  } @else if (notFound) {
    <div class="so-card so-empty">
      <span class="so-empty-icon"><i class="fa fa-user-times"></i></span>
      <h3>Profile not found</h3>
      <p>This profile doesn't exist, or it isn't available to you.</p>
      <a class="btn btn-dark" routerLink="/social-feed">Back to the feed</a>
    </div>
  } @else if (profile) {
    <section class="so-card so-hero">
      <div class="so-hero-cover"></div>
      <div class="so-hero-body">
        <span class="so-avatar so-avatar--xl">
          @if (profile.author.avatar) {
            <img [src]="imageUrl(profile.author.avatar)" alt="" (error)="profile.author.avatar = null" />
          } @else {
            {{ initials(profile.author.name) }}
          }
        </span>
        <div class="so-hero-info">
          <h1>{{ profile.author.name }}</h1>
          @if (!editingHandle) {
            <div class="so-hero-meta">
              @if (profile.handle) { <span>&#64;{{ profile.handle }}</span> }
              @if (isMe) { <button type="button" (click)="startEditHandle()">Change handle</button> }
            </div>
          } @else {
            <div class="pf-inline-edit">
              <span class="pf-at">&#64;</span>
              <input type="text" maxlength="31" autocomplete="off" spellcheck="false" aria-label="Your handle"
                [(ngModel)]="handleDraft" (keyup.enter)="saveHandle()" (keyup.escape)="editingHandle = false" />
              <button type="button" class="btn btn-theme" [disabled]="savingHandle" (click)="saveHandle()">{{ savingHandle ? 'Saving…' : 'Save' }}</button>
              <button type="button" class="btn btn-dark" (click)="editingHandle = false">Cancel</button>
            </div>
            @if (handleError) { <p class="pf-error">{{ handleError }}</p> }
          }
        </div>
        @if (!isMe) {
          <div class="so-hero-actions">
            @if (!profile.is_blocked) {
              <button type="button" class="btn" [class.btn-theme]="!profile.is_following" [class.btn-dark]="profile.is_following"
                [disabled]="followBusy" (click)="toggleFollow()">
                <i class="fa" [class.fa-check]="profile.is_following" [class.fa-user-plus]="!profile.is_following"></i>
                {{ profile.is_following ? 'Following' : 'Follow' }}
              </button>
              <button type="button" class="btn btn-dark" (click)="message()"><i class="fa fa-envelope"></i> Message</button>
            }
            <button type="button" class="btn btn-dark pf-block" [disabled]="blockBusy"
              (click)="profile.is_blocked ? unblock() : (confirmingBlock = true)">
              {{ profile.is_blocked ? 'Unblock' : 'Block' }}
            </button>
          </div>
        }
      </div>

      <div class="pf-bio">
        @if (!editingBio) {
          <p>{{ profile.bio || (isMe ? 'Add a short bio so people know who you are.' : '') }}
            @if (isMe) { <button type="button" class="pf-link" (click)="startEditBio()">{{ profile.bio ? 'Edit bio' : 'Add bio' }}</button> }
          </p>
        } @else {
          <textarea [(ngModel)]="bioDraft" rows="2" maxlength="500" placeholder="Tell people about yourself…" aria-label="Bio"></textarea>
          <div class="pf-edit-actions">
            <button type="button" class="btn btn-dark" (click)="editingBio = false">Cancel</button>
            <button type="button" class="btn btn-theme" [disabled]="savingBio" (click)="saveBio()">{{ savingBio ? 'Saving…' : 'Save' }}</button>
          </div>
        }
      </div>

      <div class="pf-stats">
        <button type="button" (click)="selectTab('followers')"><strong>{{ profile.followers_count }}</strong> follower{{ profile.followers_count === 1 ? '' : 's' }}</button>
        <button type="button" (click)="selectTab('following')"><strong>{{ profile.following_count }}</strong> following</button>
      </div>
    </section>

    @if (profile.is_blocked) {
      <div class="so-card so-empty">
        <span class="so-empty-icon"><i class="fa fa-ban"></i></span>
        <h3>You blocked {{ profile.author.name }}</h3>
        <p>You won't see each other's posts. Unblock to follow or message them again.</p>
      </div>
    } @else {
      <nav class="so-tabs" role="tablist">
        <button role="tab" [attr.aria-selected]="tab === 'posts'" (click)="selectTab('posts')">Posts</button>
        <button role="tab" [attr.aria-selected]="tab === 'followers'" (click)="selectTab('followers')">Followers</button>
        <button role="tab" [attr.aria-selected]="tab === 'following'" (click)="selectTab('following')">Following</button>
        @if (isMe) {
          <button role="tab" [attr.aria-selected]="tab === 'settings'" (click)="selectTab('settings')">Settings</button>
        }
      </nav>

      @if (tab === 'posts') {
        <div class="so-stack">
          @if (isMe) {
            <app-social-composer placeholder="Share something…" (posted)="loadPosts()"></app-social-composer>
          }
          @if (postsLoading) {
            <div class="so-card so-card-pad"><span class="so-skel" style="height: 14px"></span><span class="so-skel" style="height: 14px; width: 60%; margin-top: 10px"></span></div>
          } @else if (postsError) {
            <div class="so-card so-empty">
              <h3>Couldn't load posts</h3>
              <button type="button" class="btn btn-theme" (click)="loadPosts()">Try again</button>
            </div>
          } @else {
            @for (post of posts; track post.id) {
              <app-social-post-card [post]="post" [highlighted]="highlightId === post.id" (removed)="onRemoved($event)"></app-social-post-card>
            } @empty {
              <div class="so-card so-empty">
                <span class="so-empty-icon"><i class="fa fa-pencil"></i></span>
                <h3>No posts yet</h3>
                @if (isMe) { <p>Share something above.</p> }
              </div>
            }
            @if (hasMore) {
              <button type="button" class="so-more" [disabled]="loadingMore" (click)="loadMore()">{{ loadingMore ? 'Loading…' : 'Load more' }}</button>
            }
          }
        </div>
      }

      @if (tab === 'followers' || tab === 'following') {
        <div class="so-card">
          @if (peopleLoading) {
            <div class="so-row"><span class="so-avatar so-skel"></span><span class="so-skel" style="flex: 1; height: 14px"></span></div>
          } @else {
            <ul class="so-list">
              @for (person of people; track person.id) {
                <li class="so-row">
                  <button type="button" class="so-person" (click)="openProfile(person.id)">
                    <span class="so-avatar">
                      @if (person.avatar) { <img [src]="imageUrl(person.avatar)" alt="" (error)="person.avatar = null" /> } @else { {{ initials(person.name) }} }
                    </span>
                    <span class="so-person-text">
                      <strong>{{ person.name }}</strong>
                      @if (person.handle) { <span>&#64;{{ person.handle }}</span> }
                    </span>
                  </button>
                </li>
              } @empty {
                <li class="so-empty">
                  <h3>{{ tab === 'followers' ? 'No followers yet' : 'Not following anyone yet' }}</h3>
                </li>
              }
            </ul>
          }
        </div>
      }

      @if (tab === 'settings' && isMe) {
        <div class="so-card so-card-pad">
          <h2 class="so-section-title">Automatic posts</h2>
          <p class="so-muted pf-hint">Choose when WorldTumbler posts for you. Turning one off only stops the post; you still get your notifications.</p>
          @for (option of autoPostOptions; track option.field) {
            <label class="pf-switch">
              <span class="pf-switch-text"><strong>{{ option.label }}</strong><span>{{ option.hint }}</span></span>
              <input type="checkbox" role="switch" [checked]="profile[option.field]" [disabled]="savingSetting === option.field"
                (change)="toggleAutoPost(option.field, $any($event.target).checked)" />
              <span class="pf-toggle" aria-hidden="true"></span>
            </label>
          }
        </div>
      }
    }
  }
</app-social-shell>

<app-social-confirm-dialog
  [open]="confirmingBlock"
  title="Block this person?"
  [message]="'You and ' + (profile?.author?.name || 'they') + ' will no longer see each other\'s posts, and you\'ll stop following each other.'"
  confirmLabel="Block"
  busyLabel="Blocking…"
  [busy]="blockBusy"
  (confirm)="confirmBlock()"
  (cancel)="confirmingBlock = false"></app-social-confirm-dialog>
